// extracted by mini-css-extract-plugin
export default {"form":"form_form__bRu-g","formCard":"form_formCard__tPdzr"};